import React from 'react';
import {
    AddressLocation,
    AddressLocationControlPadding,
    AddressLocationFontSize,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
    Card,
    CardBorderRadius,
    CardBorderStyle,
    CardHeaderTheme,
    CardTheme,
} from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'cardDemo_colorcards', title: 'Color Cards' },
    { id: 'cardDemo_colorcardsheaderonly', title: 'Color Cards (Header Only)' },
    { id: 'cardDemo_headeronlyaddresslocation', title: 'Header Only - Address Location' },
    { id: 'cardDemo_transparentchildrencards', title: 'Transparent Children Cards' },
];

export const CardDemo: React.FC = () => {
    const headerContent = () => {
        return 'This is the header of the card';
    };

    const headerContentAddress = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    const subCardHeaderContent = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    const subCardHeaderContentNoIndicator = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                showIndicator={false}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    return (
        <DemoPage
            title='Cards :'
            sections={sections}
        >
            <DemoPageSection
                id={sections[0].id}
                title={sections[0].title}
            >
                <DemoExample>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Blue}
                        theme={CardTheme.Blue}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Blue Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.White}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        White Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Red}
                        theme={CardTheme.Red}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Red Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Gray}
                        theme={CardTheme.Gray}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        Gray Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Yellow}
                        theme={CardTheme.Yellow}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Yellow Panel
                    </Card>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[1].id}
                title={sections[1].title}
            >
                <DemoExample>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Blue}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Blue Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.White}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        White Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Red}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Red Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Gray}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        Gray Panel
                    </Card>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Yellow}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Yellow Panel
                    </Card>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[2].id}
                title={sections[2].title}
            >
                <DemoExample>
                    <Card
                        header={headerContentAddress()}
                        headerTheme={CardHeaderTheme.Blue}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Blue Panel
                    </Card>
                    <Card
                        header={headerContentAddress()}
                        headerTheme={CardHeaderTheme.White}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        White Panel
                    </Card>
                    <Card
                        header={headerContentAddress()}
                        headerTheme={CardHeaderTheme.Red}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Red Panel
                    </Card>
                    <Card
                        header={headerContentAddress()}
                        headerTheme={CardHeaderTheme.Gray}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                        showHeaderSeperator={true}
                    >
                        Gray Panel
                    </Card>
                    <Card
                        header={headerContentAddress()}
                        headerTheme={CardHeaderTheme.Yellow}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        Yellow Panel
                    </Card>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection
                id={sections[3].id}
                title={sections[3].title}
            >
                <DemoExample>
                    <Card
                        header={headerContent()}
                        headerTheme={CardHeaderTheme.Blue}
                        theme={CardTheme.White}
                        borderRadius={CardBorderRadius.Small}
                        borderStyle={CardBorderStyle.Solid}
                    >
                        <div style={{ margin: '1rem 0' }}>Panel With Sub Panels</div>
                        <Card
                            header={subCardHeaderContent()}
                            headerTheme={CardHeaderTheme.Gray}
                            theme={CardTheme.Transparent}
                            borderRadius={CardBorderRadius.Small}
                            borderStyle={CardBorderStyle.Solid}
                        >
                            Item 1
                        </Card>
                        <Card
                            header={subCardHeaderContent()}
                            headerTheme={CardHeaderTheme.Gray}
                            theme={CardTheme.Transparent}
                            borderRadius={CardBorderRadius.Small}
                            borderStyle={CardBorderStyle.Solid}
                        >
                            Item 2
                        </Card>
                        <Card
                            header={subCardHeaderContent()}
                            headerTheme={CardHeaderTheme.Gray}
                            theme={CardTheme.Transparent}
                            borderRadius={CardBorderRadius.Small}
                            borderStyle={CardBorderStyle.Solid}
                        >
                            Item 3
                        </Card>
                        <Card
                            header={subCardHeaderContentNoIndicator()}
                            headerTheme={CardHeaderTheme.Gray}
                            theme={CardTheme.Transparent}
                            borderRadius={CardBorderRadius.Small}
                            borderStyle={CardBorderStyle.Solid}
                        >
                            Item 4
                        </Card>
                    </Card>
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
